// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListEmployeeListCustomFiltersQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListEmployeeListCustomFiltersQuery = { __typename?: 'Query' } & {
  listEmployeeListCustomFilters: { __typename?: 'ListEmployeeListCustomFilters' } & Pick<
    Types.ListEmployeeListCustomFilters,
    'totalCount'
  > & {
      items: Array<
        { __typename?: 'EmployeeListCustomFilter' } & Pick<
          Types.EmployeeListCustomFilter,
          | 'businessUnitIds'
          | 'companyIds'
          | 'contractTypes'
          | 'createdAt'
          | 'createdById'
          | 'departmentIds'
          | 'externalAccountEloomi'
          | 'externalAccountGithub'
          | 'externalAccountGoogle'
          | 'externalAccountGreenhouse'
          | 'externalAccountHubspot'
          | 'externalAccountSlack'
          | 'id'
          | 'isLeave'
          | 'isOpenFilter'
          | 'isOnSecondment'
          | 'isExactMatch'
          | 'jobIds'
          | 'keyword'
          | 'levels'
          | 'locationIds'
          | 'divisionIds'
          | 'name'
          | 'nationalityIds'
          | 'rehireRecommendations'
          | 'replacementValues'
          | 'statuses'
          | 'team'
          | 'updatedAt'
          | 'updatedById'
          | 'managerIds'
          | 'managerIncludesAllConnections'
          | 'roles'
        > & {
            createdBy: Types.Maybe<
              { __typename?: 'Employee' } & {
                generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                  Types.EmployeeGeneralInformation,
                  'preferredFullName'
                >;
              }
            >;
            hiredDate: { __typename?: 'LocalDateRange' } & Pick<Types.LocalDateRange, 'start' | 'end'>;
            lastWorkingDate: { __typename?: 'LocalDateRange' } & Pick<Types.LocalDateRange, 'start' | 'end'>;
            employmentEndDate: { __typename?: 'LocalDateRange' } & Pick<Types.LocalDateRange, 'start' | 'end'>;
          }
      >;
    };
};

export const ListEmployeeListCustomFiltersDocument = /*#__PURE__*/ gql`
    query listEmployeeListCustomFilters {
  listEmployeeListCustomFilters {
    items {
      businessUnitIds
      companyIds
      contractTypes
      createdAt
      createdBy {
        generalInformation {
          preferredFullName
        }
      }
      createdById
      departmentIds
      externalAccountEloomi
      externalAccountGithub
      externalAccountGoogle
      externalAccountGreenhouse
      externalAccountHubspot
      externalAccountSlack
      hiredDate {
        start
        end
      }
      lastWorkingDate {
        start
        end
      }
      employmentEndDate {
        start
        end
      }
      id
      isLeave
      isOpenFilter
      isOnSecondment
      isExactMatch
      jobIds
      keyword
      levels
      locationIds
      divisionIds
      name
      nationalityIds
      rehireRecommendations
      replacementValues
      statuses
      team
      updatedAt
      updatedById
      managerIds
      managerIncludesAllConnections
      roles
    }
    totalCount
  }
}
    `;

/**
 * __useListEmployeeListCustomFiltersQuery__
 *
 * To run a query within a React component, call `useListEmployeeListCustomFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeListCustomFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeListCustomFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListEmployeeListCustomFiltersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListEmployeeListCustomFiltersQuery,
    ListEmployeeListCustomFiltersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEmployeeListCustomFiltersQuery, ListEmployeeListCustomFiltersQueryVariables>(
    ListEmployeeListCustomFiltersDocument,
    options,
  );
}
export function useListEmployeeListCustomFiltersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListEmployeeListCustomFiltersQuery,
    ListEmployeeListCustomFiltersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEmployeeListCustomFiltersQuery, ListEmployeeListCustomFiltersQueryVariables>(
    ListEmployeeListCustomFiltersDocument,
    options,
  );
}
// @ts-expect-error
export function useListEmployeeListCustomFiltersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ListEmployeeListCustomFiltersQuery,
    ListEmployeeListCustomFiltersQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<ListEmployeeListCustomFiltersQuery, ListEmployeeListCustomFiltersQueryVariables>;
export function useListEmployeeListCustomFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeeListCustomFiltersQuery, ListEmployeeListCustomFiltersQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  ListEmployeeListCustomFiltersQuery | undefined,
  ListEmployeeListCustomFiltersQueryVariables
>;
export function useListEmployeeListCustomFiltersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListEmployeeListCustomFiltersQuery, ListEmployeeListCustomFiltersQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListEmployeeListCustomFiltersQuery, ListEmployeeListCustomFiltersQueryVariables>(
    ListEmployeeListCustomFiltersDocument,
    options,
  );
}
export type ListEmployeeListCustomFiltersQueryHookResult = ReturnType<typeof useListEmployeeListCustomFiltersQuery>;
export type ListEmployeeListCustomFiltersLazyQueryHookResult = ReturnType<
  typeof useListEmployeeListCustomFiltersLazyQuery
>;
export type ListEmployeeListCustomFiltersSuspenseQueryHookResult = ReturnType<
  typeof useListEmployeeListCustomFiltersSuspenseQuery
>;
